import moment from 'moment'

import type { RestangularService } from '../../common/restangular.service'

import { app } from '../../../app.module'

/**
 * メモ追加用のコンポーネント
 * @class MemoCardActionComponentCtrl
 */
class MemoCardActionComponentCtrl {
  private objectType: string
  private objectId: string
  private objectData
  private snsType: string
  private message: string
  private isPrivate: boolean
  // 宛先リスト
  private toUsers: {
    userId: number
    name: string
    pictureUrl: string
  }[]
  // メモ追加のユーザー情報
  private createUserId: number
  private createUsername: string
  private createPictureUrl: string
  private groupId: number
  private onChangeMemoList: Function
  private isSubmit: boolean

  constructor(
    $rootScope,
    private $scope,
    private RestangularService: RestangularService,
    private DialogService
  ) {
    // メモを追加するユーザー
    this.createUserId = $rootScope.userId
    this.createUsername = $rootScope.userName
    this.createPictureUrl = $rootScope.pictureUrl
    this.groupId = $rootScope.groupId

    this.toUsers = []
    this.message = null
  }

  /**
   * メモを追加
   */
  public addMemo(): void {
    const endpoint = `/memo`
    const toUsers = this.setToUserList()
    const params = {
      // メモ対象
      memoObject: {
        objectId: this.objectId,
        objectType: this.objectType,
        objectData: this.objectData,
        snsType: this.snsType,
        groupId: this.groupId,
      },
      // メモ内容
      memoContent: {
        message: this.message,
        isPrivate: this.isPrivate ? 1 : 0,
        toUsers: toUsers,
        fromUser: {
          userId: this.createUserId,
          username: this.createUsername,
        },
      },
    }

    this.RestangularService.request('POST', endpoint, params)
      .then((result) => {
        // プライベートメモではない場合、メールを送信
        if (!this.isPrivate) {
          this.RestangularService.request('POST', '/memo/mail', params)
        }
        // メモ一覧をアップデート
        this.onChangeMemoList({
          newMemo: {
            memoId: result.memoId,
            message: this.message,
            showMemoFlg: 1,
            userId: this.createUserId,
            username: this.createUsername,
            userPictureUrl: this.createPictureUrl,
            created: moment().format('YYYY年MM月DD日 HH:mm'),
            toUsers: toUsers.usernameList,
            isPrivate: this.isPrivate ? 1 : 0,
          },
        })
        this.message = null
        this.isSubmit = false
      })
      .catch(() => {
        this.isSubmit = false
        this.DialogService.showToast('メモの追加に失敗しました。', 'error-toast')
      })
  }

  /**
   * 宛先表示用の値をセット
   */
  private setToUserList(): { usernameList: string; userIdList: number[] } {
    let usernameList = ''
    const userIdList = []

    // 宛先が指定されている場合、表示用の宛先をセット
    if (this.toUsers.length > 0) {
      this.toUsers.forEach((toUser) => {
        usernameList += usernameList ? `, ${toUser.name}` : toUser.name
        userIdList.push(toUser.userId)
      })
    }

    return {
      usernameList: usernameList,
      userIdList: userIdList,
    }
  }
}

app.component('memoCardAction', {
  bindings: {
    objectId: '<',
    objectType: '@',
    objectData: '<',
    snsType: '@',
    onChangeMemoList: '&',
  },
  template: require('./memo-card-action.pug')(),
  controller: MemoCardActionComponentCtrl,
})
